import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { UrlConstants } from "@lib/titan2/dist/game/Constants";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { StringUtil } from "@lib/titan2/dist/util/string/StringUtil";
import { WebUtil } from "@lib/titan2/dist/util/web/WebUtil";
import { BlurFilter } from "pixi.js";
import { ScatterPickEvent } from "../../../controller/event/GameEvent";
/**
* Main.ts
*/
export class Main extends AbstractGameView {
    create() {
        super.create();
        Logger.addObjectRef(this, "Main");
        // The main camera rig is the parent of all other camera rigs and scales the game to fit the screen.
        this.mainCamera = this.factory.createMainCameraRig();
        this.addChild(this.mainCamera);
        // The base game and chance game camera rigs scale the base game and chance game components separately for a parallax effect.
        this.baseGameCamera = this.factory.createBaseGameCameraRig();
        this.chanceGameBackgroundCamera = this.factory.createChanceGameBackgroundCameraRig();
        this.chanceGameForegroundCamera = this.factory.createChanceGameForegroundCameraRig();
        this.mainCamera.addChild(this.baseGameCamera, this.chanceGameBackgroundCamera, this.chanceGameForegroundCamera);
        // Create all the game components.
        this.gameBackground = this.factory.createGameBackground();
        this.portraitPaytable = this.factory.createPortraitPayTable();
        this.ticket = this.factory.createTicket();
        this.reels = this.factory.createReels();
        this.featureNotepad = this.factory.createFeatureNotepad();
        this.payTable = this.factory.createPayTable();
        this.totalWinCounter = this.factory.createTotalWinCounter();
        this.controlPanel = this.factory.createControlPanel();
        this.arcadeWheel = this.factory.createArcadeWheel();
        this.freeSpinsOverlay = this.factory.createFreeSpinsOverlay();
        this.winDisplay = this.factory.createWinDisplay();
        this.winLine = this.factory.createWinLine();
        this.winLineCelebration = this.factory.createWinLineCelebration();
        this.fullHouse = this.factory.createFullHouse();
        this.scatterPickBackground = this.factory.createScatterPickBackground();
        this.scatterPickCoconut = this.factory.createScatterPickCoconut();
        this.scatterWin = this.factory.createScatterWin();
        this.bigWin = this.factory.createBigWin();
        this.slingoParticles = this.factory.createSlingoParticles();
        this.reelWildParticles = this.factory.createReelWildParticles();
        // Add the base game components to the base game camera.
        this.baseGameCamera.addFeature(this.gameBackground, this.portraitPaytable, this.reels, this.ticket, this.winLine, this.payTable, this.totalWinCounter, this.featureNotepad, this.controlPanel, this.slingoParticles, this.reelWildParticles, this.arcadeWheel, this.freeSpinsOverlay, this.winLine, this.winLineCelebration);
        if (StringUtil.isTrue(WebUtil.getUrlParameter(UrlConstants.TEST))) {
            this.baseGameCamera.addFeature(this.factory.createTestDisplay());
        }
        // Add the chance game components to the chance game cameras.
        this.chanceGameBackgroundCamera.addFeature(this.scatterPickBackground);
        this.chanceGameForegroundCamera.addFeature(this.scatterPickCoconut);
        this.mainCamera.addChild(this.bigWin, this.fullHouse, this.scatterWin, this.winDisplay);
        // The base game will be blurred when the chance game is active.
        this.baseGameBlur = new BlurFilter(0, 3);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(ScatterPickEvent.TRANSITION_IN, this.blurBaseGame);
        this.registerGame(ScatterPickEvent.PICK_RESULT, this.unblurBaseGame);
    }
    async blurBaseGame() {
        this.baseGameCamera.filters = [this.baseGameBlur];
        await gsap.to(this.baseGameBlur, {
            blur: 8,
            duration: 2,
        });
    }
    async unblurBaseGame() {
        await gsap.to(this.baseGameBlur, {
            blur: 0,
            duration: 1,
        });
        this.baseGameCamera.filters = null;
    }
}
//# sourceMappingURL=Main.js.map